import React, { useEffect } from 'react'

import RouteLoadingPlaceholder from '../../routing/RouteLoadingPlaceholder/RouteLoadingPlaceholder'

const ReloadPage = (): React.ReactElement => {
    useEffect(() => {
        window.location.reload()
    })
    return (
        // Test id allows us to check that this component is rendered
        // Newer versions of jsdom don't allow us to mock window.location.reload
        <div data-testid="reload-page-component">
            <RouteLoadingPlaceholder />
        </div>
    )
}

export default ReloadPage
